export const WorkoutPlayerContextItem = {
  bindings: {
    data: '<',
  },

  template: `
    <i class="fa fa-chevron-right"></i>
    {{ $ctrl.data.name }}
    <i class="fa fa-info-circle" ng-if="$ctrl.data.contentHtml"></i>`,
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerContextItem.js